import { HiOutlineCube } from 'react-icons/hi2';
import { ACTIVE_NETWORKS } from '@shared/utils/config/networks';
import { useEffect, useState } from 'react';
import { BiFilterAlt } from 'react-icons/bi';
import SlidingModal from '../SlidingModal';
import NetworkDropdown from '@/components/shared/NetworkDropdown';
import { Filters, FilterTypes, TimeFilterTypes, TxFilterTypes } from '@/hooks/history/historyTypes';
import StatusFilter from './FilterModals/StatusFilter';
import TimeFilter from './FilterModals/TimeFilter';
import TokenFilter from './FilterModals/TokenFilter';
import TxTypeFilter from './FilterModals/TxTypeFilter';
import CustomDialog from '@/components/ui/customDialog';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
import { queryClient } from '@/pages/_app';
export default function HistoryFilters({
  isModalOpen,
  toggleModal,
  isMobile = true
}) {
  const usingMobile = useIsMobile();
  const defaultNetwork = ACTIVE_NETWORKS;
  const [network, setNetwork] = useState<number[]>(defaultNetwork);
  const [txStatusFilter, setTxStatusFilter] = useState<FilterTypes>(null);
  const [txTimeFilter, setTxTimeFilter] = useState<TimeFilterTypes>('all');
  const [txTypeFilter, setTxTypeFilter] = useState<TxFilterTypes>('all');
  const [tokenFilter, setTokenFilter] = useState<any>(null);
  useEffect(() => {
    const updateFilters = () => {
      const currentFilters = queryClient.getQueryData<Filters>(['history-filters']) || {
        network: ACTIVE_NETWORKS,
        txStatusFilter: 'all',
        txTimeFilter: 'all',
        tokenFilter: null,
        txTypeFilter: 'all'
      };
      const updatedFilters: Filters = {
        ...currentFilters,
        network,
        txStatusFilter,
        txTimeFilter,
        tokenFilter,
        txTypeFilter
      };
      queryClient.setQueryData(['history-filters'], updatedFilters);
      queryClient.invalidateQueries({
        queryKey: ['history-filters']
      });
    };
    updateFilters();
  }, [network, txStatusFilter, txTimeFilter, tokenFilter, txTypeFilter, queryClient]);
  const FiltersContent = () => {
    return <div className='px-4 pt-4 pb-8 w-full space-y-5' data-sentry-component="FiltersContent" data-sentry-source-file="HistoryFilters.tsx">
        <div className='flex justify-between w-full'>
          <div className='w-2/4 flex itemsn-center'>
            <p className='text-genius-cream text-[16px] flex items-center'>
              <HiOutlineCube className='w-[22px] h-[22px] ' data-sentry-element="HiOutlineCube" data-sentry-source-file="HistoryFilters.tsx" />
              <span className='ml-2 text-genius-cream/50'>Network</span>
            </p>
          </div>
          <div className='w-2/4'>
            <div className='rounded-lg w-fit px-2 float-right'>
              <NetworkDropdown setNetwork={setNetwork} network={network} defaultNetwork={defaultNetwork} isMobile={isMobile} data-sentry-element="NetworkDropdown" data-sentry-source-file="HistoryFilters.tsx" />
            </div>
          </div>
        </div>
        <StatusFilter txStatusFilter={txStatusFilter} setTxStatusFilter={setTxStatusFilter} isMobile={isMobile} data-sentry-element="StatusFilter" data-sentry-source-file="HistoryFilters.tsx" />
        <TimeFilter txTimeFilter={txTimeFilter} setTxTimeFilter={setTxTimeFilter} isMobile={isMobile} data-sentry-element="TimeFilter" data-sentry-source-file="HistoryFilters.tsx" />
        <TokenFilter tokenFilter={tokenFilter} setTokenFilter={setTokenFilter} isMobile={isMobile} data-sentry-element="TokenFilter" data-sentry-source-file="HistoryFilters.tsx" />
        <TxTypeFilter txTypeFilter={txTypeFilter} setTxTypeFilter={setTxTypeFilter} isMobile={isMobile} data-sentry-element="TxTypeFilter" data-sentry-source-file="HistoryFilters.tsx" />
      </div>;
  };
  return <>
      {!usingMobile ? <CustomDialog className={'h-[400px] w-[600px] pt-12'} trigger={<div className='rounded-full text-[16px] flex items-center justify-center bg-genius-blue h-[30px] w-[30px]'>
              <BiFilterAlt className={`text-genius-cream`} width={20} height={18} />
            </div>}>
          <div className='px-4 pt-4 pb-8 w-full space-y-5'>
            <div className='flex justify-between w-full'>
              <div className='w-2/4 flex itemsn-center'>
                <p className='text-genius-cream text-[16px] flex items-center'>
                  <HiOutlineCube className='w-[22px] h-[22px] ' />
                  <span className='ml-2 text-genius-cream/50'>Network</span>
                </p>
              </div>
              <div className='w-2/4'>
                <div className='rounded-lg w-fit px-2 float-right'>
                  <NetworkDropdown setNetwork={setNetwork} network={network} defaultNetwork={defaultNetwork} isMobile={isMobile} className={'text-[14px]'} />
                </div>
              </div>
            </div>
            <StatusFilter txStatusFilter={txStatusFilter} setTxStatusFilter={setTxStatusFilter} isMobile={isMobile} />
            <TimeFilter txTimeFilter={txTimeFilter} setTxTimeFilter={setTxTimeFilter} isMobile={isMobile} />
            <TokenFilter tokenFilter={tokenFilter} setTokenFilter={setTokenFilter} isMobile={isMobile} />
            <TxTypeFilter txTypeFilter={txTypeFilter} setTxTypeFilter={setTxTypeFilter} isMobile={isMobile} />
          </div>
        </CustomDialog> : <SlidingModal isOpen={isModalOpen} onClose={toggleModal} heightFit>
          <FiltersContent />
        </SlidingModal>}
    </>;
}